import axios from 'axios';
// import { toast } from 'react-toastify';
import ApiRoute from '../../utils/apiRoutes';
import {
  USER_LOADING_SUCCESS,
  AUTH_ERROR,
  LOGOUT,
  LOGIN_SUCCESS,
  GET_REFRESH_TOKEN,
  //   LOGIN_FAIL
} from './types';

// Create axios instance with base URL for auth requests
const axiosAuthInstance = axios.create({ baseURL: process.env.REACT_APP_BACKEND_URL });

/**
 * get new token from refresh token token
 */
export const getAccessToken = (data) => async (dispatch) => {
  try {
    const res = await axiosAuthInstance.post(ApiRoute.getAccessToken, data);
    const newToken = res?.data?.token || res?.data?.accessToken;
    if (newToken) {
      dispatch({
        type: GET_REFRESH_TOKEN,
        payload: { token: newToken },
      });
    }
    return;

  } catch (error) {
    console.log(error);
    dispatch({
      type: AUTH_ERROR,
    });
  }
};

/**
 * Logout user
 */
export const logout = () => (dispatch) => {
  dispatch({
    type: LOGOUT,
  });
};

/**
 * login user
 */
export const login = (data) => (dispatch) => {
  dispatch({
    type: LOGIN_SUCCESS,
    payload: data
  });
};

/**
 * login user
 */
 export const userLoaded = (data) => (dispatch) => {
  dispatch({
    type: USER_LOADING_SUCCESS,
    payload: data
  });
};
